import { render, staticRenderFns } from "./lunbo.vue?vue&type=template&id=bed8922a"
import script from "./lunbo.vue?vue&type=script&lang=js"
export * from "./lunbo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports